import customersIcon from "assets/images/copyrightWhite.svg";
import styles from "./FiltersConfig.module.css";

export const filtersConfig: Record<string, { className: string; icon: string | null }> = {
  customers: {
    className: styles.customers,
    icon: customersIcon,
  },
};
